// 退货地址
import React from 'react';
import { getData } from '@util';
import { Select, Spin, Tag } from 'antd';
import { API_POST_SUPPLIER_RETURN_ADDRESS_QUERY_PAGE } from '@api';
import { Debounce, Bind } from 'lodash-decorators';
class ReturnAddress extends React.PureComponent {
  state = {
    AddCodeData: [],
    loading: false,
  };

  componentDidMount() {
    this.getAddCodeFunc();
  }

  // 获取商品
  getAddCodeFunc = value => {
    this.setState({ loading: true, AddCodeData: [] });
    getData({
      api: API_POST_SUPPLIER_RETURN_ADDRESS_QUERY_PAGE,
      data: {
        keyword: value,
        pageNum: 1,
        pageSize: 10,
      },
    })
      .then(res => {
        const { data } = res?.data || {};
        this.setState({
          AddCodeData: data,
          loading: false,
        });
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  };

  @Bind()
  @Debounce(1000)
  handleSearch(value) {
    if (!value) return false;
    this.getAddCodeFunc(value);
  }

  render() {
    const { AddCodeData, loading } = this.state;
    const { isSingleSelect, renderItem } = this.props;
    return (
      <Select
        mode={!isSingleSelect && 'tags'}
        tokenSeparators={[' ', ',', '，', '	']}
        optionFilterProp="children"
        allowClear
        showArrow
        className="multiple-select-and-search"
        filterOption={false}
        notFoundContent={loading ? <Spin size="small" /> : '查询结果为空'}
        onSearch={this.handleSearch}
        showSearch
        dropdownMatchSelectWidth={false}
        placeholder={'请选择'}
        {...this.props}
        onChange={x => {
          if (!isSingleSelect) {
            const y = Array.from(new Set(x));
            this.props.onChange && this.props.onChange(y);
          } else {
            this.props.onChange && this.props.onChange(x);
          }
        }}>
        {AddCodeData.map(item => (
          <Select.Option
            title={`${item.receivePerson} ${item.contactPhone} | ${item.provinceName}${item.cityName}${item.areaName} ${item.detailAddress}`}
            key={item.id}
            item={item}
            value={renderItem ? renderItem(item) : item.id}
            style={{
              maxWidth: 800,
              whiteSpace: 'normal',
              wordBreak: 'break-all',
              height: 'auto',
              lineHeight: 1.5,
              padding: '5px 12px',
            }}>
            {item.isDefault === 1 && <Tag color="#87d068">默认</Tag>}
            {item.receivePerson} {item.contactPhone} | {item.provinceName}
            {item.cityName}
            {item.areaName}
            {item.detailAddress}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

export default ReturnAddress;
